<template>
  <div class="box">
    <!-- 顶部组件 -->
    <top-navigation
      :loginDialog="loginDialog"
      @loginClose="loginClose"
    ></top-navigation>
    <!-- 内容 -->
    <div class="conent">
      <div class="top">
        <el-button size="medium" plain @click="$router.go(-1)">返回上一页</el-button>
        <span>当前位置：首页-品牌界学者</span>
      </div>
      <div class="detail">
        <div class="detailBox" v-for="(item,index) in list" :key="index">
          <img :src="item.expertUrl" alt="" />
          <div class="detailBox2">
            <div class="detailName">{{item.expertName}}</div>
            <div class="line"></div>
            <div class="synopsis">{{item.expertPost}}</div>
            <div class="mainBody">{{item.brief}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <footer-2></footer-2>
  </div>
</template>

<script>
import Footer2 from "../../components/footer/footer2.vue";
import topNavigation from "../../components/topNavigation/topNavigation.vue";
import { getExpertList } from "@/api/public";
export default {
  components: { topNavigation, Footer2 },
  data() {
    return {
      loginDialog: false, // 登录弹窗状态
      list: "",
    };
  },
  created() {
    window.scrollTo(0, 0); // 回滚
    this.getData();
  },
  methods: {
    getData() {
      getExpertList({ search: "" }).then((res) => {
        if (res.code == 200) {
          this.list = res.data;
        }
      });
    },
    // 登录状态回调
    loginClose(data) {
      this.loginDialog = data;
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (min-width: 0px) and (max-width: 1440px) {
  .mt {
    width: 1440px;
    margin: 0 auto;
  }
  .box {
    min-width: 1440px;
  }
  .thesisBox {
    width: 1156px;
  }
}
@media screen and (min-width: 1441px) and (max-width: 1920px) {
  .mt {
    width: 1680px;
    margin: 0 auto;
  }
  .box {
    min-width: 1680px;
  }
  .thesisBox {
    width: 1396px;
  }
}
.flex-row-start {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}
.flex-row-between {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
}
.box {
  background: #f3f5f9;
}
.close {
  float: left;
  width: 36px;
  height: 36px;
  cursor: pointer;
  transform: rotate(-90deg);
}
/deep/.el-pagination {
  margin-top: 20px;
  float: right;
  .el-pager li {
    font-size: 14px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #8996a0;
    line-height: 28px;
    width: 28px;
    height: 28px;
    background: #ffffff;
    border-radius: 3px;
  }
  .btn-next {
    width: 56px;
    height: 28px;
    background: #ffffff;
    line-height: 28px;
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #a4c7ff;
  color: #fff;
}

.conent {
  width: 1200px;
  margin: 0 auto;
  .top {
    margin-top: 35px;
    margin-bottom: 34px;
    span {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 22px;
      margin-left: 24px;
    }
  }
  .detail {
    .detailBox {
      width: 1180px;
      height: 426px;
      background: #ffffff;
      margin-left: 20px;
      position: relative;
      margin-bottom: 28px;
      img {
        width: 236px;
        height: 320px;
        background: #c3dfff;
        position: absolute;
        top: -20px;
        left: -20px;
      }
      .detailBox2 {
        margin-left: 248px;
        padding: 23px 35px 34px 0;
        box-sizing: border-box;
      }
      .detailName {
        font-size: 24px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #203644;
        line-height: 32px;
        letter-spacing: 2px;
      }
      .line {
        width: 30px;
        height: 6px;
        background: #2687fa;
        margin-top: 16px;
      }
      .synopsis {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #203644;
        line-height: 22px;
        margin-top: 22px;
      }
      .mainBody {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #8997a1;
        line-height: 20px;
        margin-top: 16px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/other/teamDetail.vue